import { createTheme } from '@mui/material'
import { amber, lightGreen } from '@mui/material/colors'

export const theme = createTheme({
  palette: {
    primary: lightGreen,
    secondary: amber,
  }
})
